import React, { useState, useCallback, useEffect, useRef } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    FormHelperText,
    Select,
    FormControl,
    InputLabel,
    InputAdornment,
    MenuItem,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Stack,
    Avatar,
    IconButton,
    Chip,
    styled,
    Container,
    ListItem,
    ListItemButton,
    List,
    Fab,
    Table,
    TableContainer,
    TableCell,
    TableRow,
    TableBody,
    TableHead,
    Badge,
    Link,
    Tooltip
} from '@mui/material';

import dayjs from "dayjs";

import { DataGrid, GridCellEditStopReasons, useGridApiContext } from '@mui/x-data-grid';

import { blue, green, grey, orange, red } from "@mui/material/colors";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useSystemPrompt } from "../../../../../hooks/useSystemPrompt";
import { useAppContextFeatures } from "../../../../../context/AppContext"
import { CommonIcons, icons } from '../../../../../components/common/CommonIcons'
// import { useSystemUtils } from "../../../../../hooks/useSystemUtils";
import { useSystemRoutes, routeTypes } from "../../../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../../hooks/usePermissions';

import { useFiles, fileModuleTypes, fileReferenceTypes, targetTypes as fileTargetTypes } from '../../../../../hooks/api/useFiles';
import { useTranslations } from "../../../../../hooks/useTranslations";

import CommonBreadcumbs from "../../../../../components/common/CommonBreadcumbs";
import CommonSectionHeader from "../../../../../components/common/CommonSectionHeader";
import CommonRestricted from "../../../../../components/common/CommonRestricted";

import ActionConfirm from "../../../../../components/dialog/ActionConfirm"

import { useContainer } from "../../../hooks/model/useContainer"
import {
    useProductItem,
    getUniqueItemCode,
    itemInjectionFields,
    defaultUom,
    itemUoms as supportedItemUoms,
} from "../../../hooks/model/useProductItem";
import {
    useProduct,
    productImageTypes,
    productLoadStatusTypes,
    calculateCbmByDimension,
    productInjectionFields
} from "../../../hooks/model/useProduct"
import { useContainerSummary } from "../../../hooks/model/useContainerSummary"

import { useAuthAccess } from "../../../../../hooks/useAuthAccess"

import { getInjectionDataType } from "../../../utils/injectionSelection";

import UpdateProductMain from "./section/UpdateProductMain";
import UpdateProductItem from "./section/UpdateProductItem";
// import AddProductItems from "./section/AddProductItems";
import AddProductItemsV2 from "./section/AddProductItemsV2";
import AddProductItems from "./section/AddProductItems";
import UpdateProductIdentity from "./section/UpdateProductIdentity"
import UpdateProductImages from "./section/UpdateProductImages"

import CommonDialog from "../../common/CommonDialog"

import { formatRoundValue } from "../../../utils/formatNumber"

export const StyledIcon = styled(Box)({
    width: 100,
    height: 100,
    opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    // minHeight: 450
}));

// const StyledTypography = styled(Typography)(({ theme }) => ({
//     fontSize: 20,
//     fontWeight: 600,
//     color: green[500]
// }));

const StyledCell = styled(TableCell)(({ theme }) => ({
    fontSize: 20,
    fontWeight: 600,
    // color: `green !important`
    backgroundColor: green[200]
}));


// const StyledLabel = styled(Typography)(({ theme }) => ({
//     fontSize: '0.9rem',
//     fontWeight: 800
// }))

// const StyledContent = styled(Typography)(({ theme }) => ({
//     fontSize: '0.9rem'
// }))

// const StyledDivider = styled(Divider)(({ theme }) => ({
//     mt: 1,
//     mb: 0,
//     borderStyle: 'dashed'
// }))

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    '.super-app-theme--cell': {
        padding: 0,
        color: `black !important`,
        margin: 0,
        fontSize: 13,
        fontWeight: 700,
        paddingLeft: 5,
        paddingRight: 5,
        // backgroundColor: '#f3f3f3',
        // backgroundColor: 'red',
        borderRight: '1px solid #000',
        borderBottom: '1px solid #000',
        // '&.Mui-selectb
    },
    '.super-app-theme--cellEditable': {
        padding: 0,
        margin: 0,
        fontSize: 13,
        color: `black !important`,
        paddingLeft: 5,
        paddingRight: 5,
        borderRight: '1px solid #000',
        borderBottom: '1px solid #000',
        // '&.Mui-selected': {
        //     backgroundColor: '#fff',
        //     '&:hover': {
        //         backgroundColor: '#fff',
        //     },
        // },
    },
    '.super-app-theme--Unsaved': {
        // padding: 0,
        // margin: 0,
        // fontSize: 13,
        // paddingLeft: 5,
        // paddingRight: 5,
        backgroundColor: 'yellow !important',
        '&.Mui-selected': {
            backgroundColor: 'yellow !important',
            '&:hover': {
                backgroundColor: 'yellow !important',
            },
        },
    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#1976d2',
        color: '#fff',
        fontWeight: 'bold',
        fontSize: 14,
        borderBottom: '2px solid #1565c0',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: '600',
        paddingTop: 0,
        marginTop: 0
    },
    '.MuiDataGrid-columnHeaders .MuiCheckbox-root': {
        color: 'white !important',
    },
    '.MuiDataGrid-row:nth-of-type(even)': {
        baeckgroundColor: `#ffffff`,
    },
    '.MuiDataGrid-row:nth-of-type(odd)': {
        backgroundColor: `${grey[200]}`,
    },

}));

const RenderItems = ({ editableData, onResetUpdateItem, onProcessRowUpdate, onHandleUpdateItem, selectedIds, onHandleChangeRowSelect }) => {

    const { promptMessage } = useSystemPrompt();

    const { t } = useTranslations({ ns: ["_@products", "_@repositories", "_@parcel", "_prompt", "common", "_common"] })

    // const [editValue, setEditValue] = useState("")

    // const uoms = supportedItemUoms

    const columns = [
        // { field: `model`, headerName: t("model"), width: 180, editable: true },
        {
            cellClassName: 'super-app-theme--cell', type: 'number', field: `indexno`, align: 'center', headerName: `#`, width: '15', sortable: false, editable: false,
            renderCell: (params) => {

                let indexNo = params.row?.indexno
                let itemId = params.row?.id
                let productId = params.row?.product_id

                // let array = values.map(i => ({ docNumber: i?.document_number, id: i?.document_id }))

                return (
                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        sx={{
                            // backgroundColor: 'red',
                            flex: 1
                        }}
                    >
                        {/* <Link
                            href="#"
                            underline={"none"}
                            onClick={() => {
                                // onHandleUpdateItem(itemId, productId)
                            }}
                        >
                            {indexNo}
                        </Link> */}

                        <IconButton
                            color={"primary"}
                            onClick={() => {
                                onHandleUpdateItem(itemId, productId)
                            }}
                        >
                            <CommonIcons name={icons.edit} sx={{ width: 15, height: 15 }} />
                            <Typography
                                sx={{
                                    fontSize: 13
                                }}
                            >
                                {indexNo}
                            </Typography>
                        </IconButton>

                        {/* <IconButton
                            // disabled={
                            //     inputDisabled
                            // }
                            color={"primary"}
                            size="small"
                            onClick={() => {

                                // console.log('productId', productId, itemId)
                                onHandleUpdateItem(itemId, productId)

                            }}
                        >
                            <CommonIcons name={icons.edit} />
                        </IconButton> */}
                        {/* <Typography
                            sx={{
                                fontSize: 13,
                            }}
                        >{}</Typography> */}
                    </Box>
                )
            },
        },
        { cellClassName: 'super-app-theme--cellEditable', type: 'string', field: `_item_remark`, headerName: t("model"), width: '130', sortable: false, editable: true },
        { cellClassName: 'super-app-theme--cellEditable', type: 'string', field: `_item_description`, headerName: t("itemName"), width: '130', sortable: false, editable: true },
        { cellClassName: 'super-app-theme--cellEditable', type: 'number', field: `_handle_qty`, headerName: t("handleQty"), width: '70', sortable: false, editable: true },
        { cellClassName: 'super-app-theme--cellEditable', type: 'number', field: `_uom_price`, headerName: t("unitPrice"), width: '70', sortable: false, editable: true },
        { cellClassName: 'super-app-theme--cellEditable', type: 'number', field: `_qty_per_package`, headerName: t("pcsCtn"), width: '70', sortable: false, editable: true },
        { cellClassName: 'super-app-theme--cellEditable', type: 'number', field: `_dimension_length`, headerName: t("length"), width: '70', sortable: false, editable: true },
        { cellClassName: 'super-app-theme--cellEditable', type: 'number', field: `_dimension_width`, headerName: t("width"), width: '70', sortable: false, editable: true },
        { cellClassName: 'super-app-theme--cellEditable', type: 'number', field: `_dimension_height`, headerName: t("height"), width: '70', sortable: false, editable: true },

        { cellClassName: 'super-app-theme--cellEditable', type: 'number', field: `_pack_qty`, headerName: t("packUnit"), width: '70', sortable: false, editable: true },

        {
            cellClassName: 'super-app-theme--cellEditable',
            type: 'singleSelect',
            // valueOptions: supportedItemUoms.map(i => i.value),
            valueOptions: supportedItemUoms.map(i => t(i.display)),
            align: 'center',
            field: `_uom_name`,
            headerName: t("uom"),
            width: '80',
            sortable: false,
            editable: true
        },

        { cellClassName: 'super-app-theme--cellEditable', type: 'number', field: `_weight`, headerName: t("weight"), width: '90', sortable: false, editable: true },

        { cellClassName: 'super-app-theme--cell', type: 'number', field: `_cbm`, headerName: t("cbm"), width: '90', sortable: false, editable: false },
        { cellClassName: 'super-app-theme--cell', type: 'number', field: `_total_cbm`, headerName: t("tCbm"), width: '100', sortable: false, editable: false },
        { cellClassName: 'super-app-theme--cell', type: 'number', field: `_total_weight`, headerName: t("tWeight"), width: '100', sortable: false, editable: false },
        { cellClassName: 'super-app-theme--cell', type: 'number', field: `_total_value`, headerName: t("tValue"), width: '100', sortable: false, editable: false },
        {
            cellClassName: 'super-app-theme--cell', type: 'string', headerAlign: 'center', align: 'left', field: `isChanged`, headerName: t("action"), width: '100', sortable: false, editable: false,
            renderCell: (params) => {

                let isChanged = params.row?.isChanged
                let itemId = params.row?.id
                let productId = params.row?.product_id

                // let array = values.map(i => ({ docNumber: i?.document_number, id: i?.document_id }))

                return (
                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        sx={{
                            // backgroundColor: 'red',
                            flex: 1,
                            px: 1,
                        }}
                    >
                        <Box>
                            {
                                isChanged === "" ?
                                    (
                                        <Typography
                                            sx={{
                                                fontSize: 13,
                                            }}
                                        >-</Typography>
                                    )
                                    :
                                    (
                                        <Button
                                            color={"primary"}
                                            sx={{
                                                backgroundColor: 'yellow'
                                            }}
                                            size="small"
                                            onClick={() => {
                                                // handleResetUpdateItem
                                                // console.log('sdfdsfsd');
                                                onResetUpdateItem(params.row)
                                            }}
                                        >
                                            <CommonIcons
                                                name={icons.reset}
                                                sx={{
                                                    width: 14,
                                                    height: 14
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    pl: 0.5,
                                                    fontSize: 13
                                                }}
                                            >
                                                {t("reset")}
                                            </Typography>
                                        </Button>
                                    )
                            }
                        </Box>
                    </Box>
                )
            },
        },

    ];

    const processRowUpdate = (updatedRow, originalRow) => {

        return new Promise((resolve, reject) => {

            // console.log('update', updatedRow, originalRow)

            if (JSON.stringify(updatedRow) === JSON.stringify(originalRow)) {
                reject(new Error(`No changes on the row`))
            } else {

                // check the updating rows exists
                let a = editableData.pendingUpdate.filter(i => i.id === updatedRow.id)

                // console.log('a', a)

                let currentPendingUpdateItems = editableData.pendingUpdate

                // console.log('updatedRow', updatedRow)

                if (a.length <= 0) { // not found - append new
                    currentPendingUpdateItems.push(updatedRow)
                } else {
                    let _currentPendingUpdateItems = currentPendingUpdateItems
                    currentPendingUpdateItems = _currentPendingUpdateItems.filter(i => i.id !== updatedRow.id)
                    currentPendingUpdateItems.push(updatedRow)
                }

                if (onProcessRowUpdate) {
                    onProcessRowUpdate(currentPendingUpdateItems)
                }

                resolve(updatedRow)

            }

        })

    }

    if (editableData.items.length <= 0) return <></>

    let _rows = editableData.items
    let _rowsPendingUpdate = editableData.pendingUpdate

    // console.log('editableData', editableData)

    let rows = []

    _rows.forEach((i5, index5) => {

        let check = _rowsPendingUpdate.filter(i2 => i2.id === i5.id)

        // console.log('check', check)

        if (check.length <= 0) {
            rows.push({
                indexno: (index5 + 1),
                ...i5,
                isChanged: ``
            })
        } else {
            rows.push({
                indexno: (index5 + 1),
                ...check[0],
                isChanged: `Unsaved`
            })
        }

    })

    // console.log('rows', rows)

    return (
        <StyledCard
            sx={{
                p: 0
            }}
        >
            <Box
                sx={{
                    // minHeight: 400
                }}
            >
                <StyledDataGrid
                    sx={{
                        p: 0,
                        fontSize: 12,
                        // minHeight: 350,
                        // '.MuiDataGrid-row:nth-of-type(even)': {
                        //     baeckgroundColor: grey[300],
                        // },
                        // '.MuiDataGrid-row:nth-of-type(odd)': {
                        //     backgroundColor: '#ffffff',
                        // },
                    }}
                    rows={rows}
                    columns={columns}
                    processRowUpdate={processRowUpdate}
                    onProcessRowUpdateError={(error) => {
                        // console.log('error', error)
                        promptMessage(false, `${error}`)
                    }}
                    // onCellKeyDown={(props) => {
                    //     console.log('props', props)
                    // }}
                    // onCellEditStop={(params, event) => {

                    //     console.log('poarams', params, event)

                    //     if (params.reason === GridCellEditStopReasons.cellFocusOut) {
                    //         event.defaultMuiPrevented = true;
                    //     }
                    // }}
                    checkboxSelection
                    rowHeight={25}
                    getRowClassName={(params) => `super-app-theme--${params.row.isChanged}`}

                    disableRowSelectionOnClick
                    rowSelectionModel={selectedIds}
                    onRowSelectionModelChange={(ids) => {
                        // console.log('props', ids)

                        // const selectedIDs = new Set(ids);
                        // const selectedRowData = rows.filter((row) => selectedIDs.has(row.id.toString()))

                        // console.log(selectedRowData);

                        if (onHandleChangeRowSelect) {
                            onHandleChangeRowSelect(ids)
                        }

                    }}

                // onCellEditStart={(params, event) => {
                //     // event.target.select()
                //     console.log('a', params, event)

                //     if (event?.target?.select) {
                //         event.target.select()
                //     }
                // }}

                />
            </Box>
        </StyledCard>
    )
}

const RenderFabs = ({
    productId,
    editableData,
    selectedIds,
    handleAddProductItem,
    handleAddProductItemV1,
    handleDeleteBulkItems,
    handleUpdateBulkItems,
    t
}) => {

    // check the modify update pending 
    let totalPendingUpdateItems = editableData.pendingUpdate.length
    let totalSelectedIds = selectedIds.length

    // console.log('totalPendingUpdateItems', totalPendingUpdateItems)

    let maxAllowed = 10

    let enableSaveBulkItems = false

    if (totalPendingUpdateItems > 0) {

        if (totalPendingUpdateItems <= maxAllowed) {
            enableSaveBulkItems = true
        }
    }

    let enableDeleteBulkItems = false

    if (totalSelectedIds > 0) {

        if (totalSelectedIds <= maxAllowed) {
            enableDeleteBulkItems = true
        }
    }

    return (
        <>
            <Tooltip title={t("tableGridV2")}>
                <Fab
                    // size="small"
                    color="primary"
                    aria-label="add"
                    sx={{
                        position: 'fixed',
                        bottom: 202,
                        right: 16,
                    }}
                    onClick={() => {
                        handleAddProductItem({ productId })
                    }}
                // disabled={
                //     Boolean(!enableDeleteBulkItems)
                // }
                >
                    <CommonIcons name={icons.newGrid} />
                </Fab>
            </Tooltip>

            <Tooltip title={t("tableGridV1")}>
                <Fab
                    // size="small"
                    color="primary"
                    aria-label="add"
                    sx={{
                        position: 'fixed',
                        bottom: 140,
                        right: 16,
                    }}
                    onClick={() => {
                        handleAddProductItemV1({ productId })
                    }}
                >
                    <CommonIcons name={icons.plus} />
                </Fab>
            </Tooltip>

            <Fab
                // size="small"
                color="error"
                aria-label="remove"
                sx={{
                    position: 'fixed',
                    bottom: 78,
                    right: 16,
                }}
                onClick={() => {
                    // console.log('se', selectedIds)
                    handleDeleteBulkItems({ itemIds: selectedIds })
                }}
                disabled={
                    Boolean(!enableDeleteBulkItems)
                }
            >
                <Badge
                    badgeContent={
                        selectedIds.length
                    }
                    color="warning"
                >
                    <CommonIcons name={icons.remove} />
                </Badge>
            </Fab>
            <Fab
                // size="small"
                color="primary"
                aria-label="save"
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                }}
                onClick={async () => {
                    await handleUpdateBulkItems()

                    // setEditableData({
                    //     ...editableData,
                    //     pendingUpdate: []
                    // })

                }}
                disabled={
                    Boolean(!enableSaveBulkItems)
                }
            >
                <Badge
                    badgeContent={
                        totalPendingUpdateItems
                    }
                    color="warning"
                >
                    <CommonIcons name={icons.save} />
                </Badge>
            </Fab>
        </>
    )
}

const RenderAssignedDO = ({ t, data }) => {

    let _isAssignedDO = data[productInjectionFields.isAssignedDO.retrieveKey]
    let _assignedDONumber = data[productInjectionFields.assignedDONumber.retrieveKey]
    let _assignedDORemId = data[productInjectionFields.assignedDORemId.retrieveKey]

    let isAssignedDO = _isAssignedDO ? parseInt(_isAssignedDO, 10) : false

    // console.log('isAssignedDO : ', isAssignedDO)

    // check is not assigned
    if (isAssignedDO === false) {
        return (
            <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
            >
                <CommonIcons
                    name={icons.documents}
                    sx={{
                        mr: 1,
                        color: grey[500],
                        width: 25,
                        height: 25
                    }}
                />
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"flex-start"}
                >
                    <Typography
                        sx={{
                            fontSize: 15,
                            fontWeight: 800,
                            color: grey[500]
                        }}
                    >
                        {
                            `${t("assignedDO")}`
                        }
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: 13,
                            // fontWeight: 800,
                            color: grey[500],
                            mt: -0.5
                        }}
                    >
                        {
                            `-`
                        }
                    </Typography>
                </Box>
            </Box>
        )
    }

    return (
        <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
        >
            <CommonIcons
                name={icons.documents}
                sx={{
                    mr: 1,
                    color: grey[800],
                    width: 25,
                    height: 25
                }}
            />
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"flex-start"}
            >
                <Typography
                    sx={{
                        fontSize: 15,
                        fontWeight: 800,
                        color: grey[800]
                    }}
                >
                    {
                        `${t("assignedDO")}`
                    }
                </Typography>
                <Typography
                    sx={{
                        fontSize: 13,
                        // fontWeight: 800,
                        color: grey[800],
                        mt: -0.5
                    }}
                >
                    {
                        `${_assignedDONumber} (${_assignedDORemId})`
                    }
                </Typography>
            </Box>
        </Box>
        // <Chip
        //     sx={{
        //         ml: 1
        //     }}
        //     color="warning"
        //     size="small"
        //     label={
        //         
        //     }
        // />
    )
}

const RenderLastUpdate = ({ t, data }) => {

    let lastUpdateDatetime = data[productInjectionFields.lastUpdateDatetime.retrieveKey]
    let lastUpdateUserId = data[productInjectionFields.lastUpdateUserId.retrieveKey]
    let lastUpdateUserDisplay = data[productInjectionFields.lastUpdateUserDisplay.retrieveKey]

    let color = grey[500]

    if (lastUpdateUserDisplay) {
        color = grey[800]
    }

    return (
        <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            width={'auto'}
        >
            <CommonIcons
                name={icons.save}
                sx={{
                    mr: 1,
                    color,
                    width: 25,
                    height: 25
                }}
            />
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"flex-start"}
            >
                <Typography
                    sx={{
                        fontSize: 15,
                        fontWeight: 800,
                        color
                    }}
                >
                    {
                        `${t("lastSaved")}`
                    }
                </Typography>
                <Typography
                    sx={{
                        fontSize: 13,
                        // fontWeight: 800,
                        color,
                        mt: -0.5
                    }}
                >
                    {
                        lastUpdateUserDisplay ?
                            (
                                `${lastUpdateUserDisplay} (${lastUpdateDatetime})`
                            )
                            :
                            (
                                `-`
                            )
                    }
                </Typography>
            </Box>
        </Box>
        // <Chip
        //     sx={{
        //         ml: 1
        //     }}
        //     color="warning"
        //     size="small"
        //     label={
        //         
        //     }
        // />
    )
}

const RenderLabelPackQty = ({ t, data }) => {

    let printPackQty = parseFloat(data[productInjectionFields.appPrintPackQty.retrieveKey]).toFixed(0)

    let color = grey[500]
    let fontSize = 13
    let colorTitle = grey[500]

    if (printPackQty !== "0") {
        fontSize = 20
        color = orange[500]
        colorTitle = grey[800]
    }

    return (
        <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
        >
            <CommonIcons
                name={icons.print}
                sx={{
                    mr: 1,
                    width: 25,
                    height: 25,
                    color: colorTitle
                }}
            />
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"flex-start"}
            >
                <Typography
                    sx={{
                        fontSize: 15,
                        fontWeight: 800,
                        color: colorTitle
                    }}
                >
                    {
                        `${t("printPackQty")}`
                    }
                </Typography>
                <Typography sx={{ fontSize, mt: -0.5, color, fontWeight: 700 }} >
                    {printPackQty}
                </Typography>
            </Box>
        </Box>
    )
}

const RenderAppEntry = ({ t, data }) => {

    let appEntry = data[productInjectionFields.isAppEntry.retrieveKey]

    let color = grey[500]

    if (appEntry === "1") {
        color = grey[800]
    }

    return (
        <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
        >
            <CommonIcons
                name={icons.mobile}
                sx={{
                    mr: 1,
                    width: 25,
                    height: 25,
                    color
                }}
            />
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"flex-start"}
            >
                <Typography
                    sx={{
                        fontSize: 15,
                        fontWeight: 800,
                        color
                    }}
                >
                    {
                        `${t("appEntry")}`
                    }
                </Typography>
                <Typography
                    sx={{
                        fontSize: 13,
                        fontWeight: 600,
                        mt: -0.5,
                        color
                    }}
                >
                    {
                        (appEntry === "1") ?
                            t('byApp') : t("notFromApp")
                    }
                </Typography>
            </Box>
        </Box>
    )
}

const RenderSectionProduct = ({
    t,
    productId,
    data,
    dataFiles,
    dataNfc,
    handleProductImages,
    handleIndentityInfo,
    handleEditProduct,
}) => {

    if (!data?.product) return <></>

    // const { product } = data;
    let item = data?.product

    let isSplit = item[productInjectionFields.isSplit.retrieveKey]
    let splitFromRemId = item[productInjectionFields.splitFromRemId.retrieveKey]

    let checkedInDateTimeDisplay = `-`

    if (item[productInjectionFields.checkinDateTime.retrieveKey]) {
        checkedInDateTimeDisplay = dayjs(item[productInjectionFields.checkinDateTime.retrieveKey]).format("YYYY-MM-DD h:mm:ssA")
    }

    return (
        <StyledCard>
            <Grid container spacing={0.5}>
                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                    >
                        <CommonSectionHeader
                            title={t('information')}
                            subTitle={t('detailInformationDescribedTheProducts')}
                        />
                        <Box
                            display={"flex"}
                            flexDirection={"column"}
                            justifyContent={"flex-start"}
                            alignItems={"center"}
                        >

                            <Chip
                                sx={{
                                    ml: 1
                                }}
                                color="primary"
                                size="small"
                                label={
                                    <Typography
                                        sx={{
                                            fontSize: 13
                                        }}
                                    >
                                        {
                                            `${t("checkedInAt")} : ${checkedInDateTimeDisplay}`
                                        }
                                    </Typography>
                                }
                            />

                            {
                                parseInt(isSplit, 10) === 1 &&
                                <Chip
                                    sx={{
                                        ml: 1
                                    }}
                                    color="warning"
                                    size="small"
                                    label={
                                        <Typography
                                            sx={{
                                                fontSize: 13
                                            }}
                                        >
                                            {
                                                `${t("isSplit")}: ${splitFromRemId}`
                                            }
                                        </Typography>
                                    }
                                />
                            }
                        </Box>

                    </Box>

                </Grid>

                <Grid item xs={12} sm={12} md={6} textAlign={"right"} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} alignSelf={"center"}>

                    {/* {JSON.stringify(dataFiles)} */}

                    <RenderLabelPackQty
                        t={t}
                        data={item}
                    />

                    <RenderAppEntry
                        t={t}
                        data={item}
                    />

                    <RenderLastUpdate
                        t={t}
                        data={item}
                    />

                    <RenderAssignedDO
                        t={t}
                        data={item}
                    />

                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"flex-end"}
                        alignItems={"center"}
                    >
                        <IconButton
                            color="primary"
                            size="large"
                            onClick={() => {
                                handleProductImages()
                            }}
                        >
                            {
                                dataFiles?.gallery.length > 0 ?
                                    (
                                        <Badge badgeContent={dataFiles?.gallery.length} color="primary">
                                            <CommonIcons name={icons.image} />
                                        </Badge>
                                    )
                                    :
                                    (
                                        <Badge badgeContent={'0'} color="error">
                                            <CommonIcons name={icons.image} />
                                        </Badge>
                                    )
                            }
                        </IconButton>

                        {/* <IconButton
                            color="primary"
                            size="large"
                            onClick={() => {
                                handleIndentityInfo()
                            }}
                        >
                            {
                                dataNfc?.identityNo ?
                                    (
                                        <Badge badgeContent={'1'} color="primary">
                                            <CommonIcons name={icons.identity} />
                                        </Badge>
                                    )
                                    :
                                    (
                                        <Badge badgeContent={'0'} color="error">
                                            <CommonIcons name={icons.identity} />
                                        </Badge>
                                    )
                            }
                        </IconButton> */}

                        <IconButton
                            // disabled={
                            //     inputDisabled
                            // }
                            color="primary"
                            size="large"
                            onClick={() => {
                                handleEditProduct({ productId })
                            }}
                        >
                            <CommonIcons name={icons.edit} />
                        </IconButton>
                    </Box>

                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                    <RenderProduct
                        t={t}
                        data={data}
                    />
                </Grid>

            </Grid>
        </StyledCard>
    )
}

const RenderProduct = ({ t, data }) => {

    let item = data?.product

    return (
        <TableContainer
        >
            <Table
                // sx={{ minWidth: 650 }} 
                sx={{
                    "& .MuiTableCell-root": {
                        border: "1px solid rgba(224, 224, 224, 1)",
                        color: 'black !important'
                    }
                }}
                size="small"
                aria-label="a dense table"
            >
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={1}>{t('createdatetime')}</TableCell>
                        <TableCell colSpan={1}>{t('barcode')}</TableCell>
                        <TableCell colSpan={2}>{t('signedBy')}</TableCell>
                        <TableCell colSpan={2}>{t('location')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell colSpan={1}>{item?.ax_createdatetime}</TableCell>
                        <TableCell colSpan={1}>{item[productInjectionFields.barcode.retrieveKey]}</TableCell>
                        <StyledCell colSpan={2}>
                            {/* <StyledTypography> */}
                            {item[productInjectionFields.signedByUserDisplay.retrieveKey]}
                            {/* </StyledTypography> */}
                        </StyledCell>
                        <TableCell colSpan={2}>{item[productInjectionFields.registerLocationDisplay.retrieveKey]}</TableCell>
                    </TableRow>
                </TableBody>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('supplierName')}</TableCell>
                        <TableCell>{t('supplierContact')}</TableCell>
                        <TableCell colSpan={2}>{t('marking')}</TableCell>
                        <TableCell colSpan={2}>{t('courierNo')}</TableCell>
                        {/* <TableCell>{t('productName')}</TableCell>
                            <TableCell>{t('model')}</TableCell> */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>{item[productInjectionFields.supplierName.retrieveKey]}</TableCell>
                        <TableCell>{item[productInjectionFields.supplierContact.retrieveKey]}</TableCell>
                        <StyledCell colSpan={2}>
                            {/* <StyledTypography> */}
                            {item[productInjectionFields.customerMarking.retrieveKey]}
                            {/* </StyledTypography> */}
                        </StyledCell>
                        <TableCell colSpan={2}>{item[productInjectionFields.courierTrackingNo.retrieveKey]}</TableCell>
                        {/* <TableCell>{item?.item_name}</TableCell>
                            <TableCell>{item?.model}</TableCell> */}
                    </TableRow>
                </TableBody>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('supplierPurchaseNo')}</TableCell>
                        <TableCell>{t('companyPurchaseNo')}</TableCell>
                        <TableCell>{t('prepayDepositFee')}</TableCell>
                        <TableCell>{t('prepayTransportFee')}</TableCell>
                        <TableCell colSpan={2}>{t('remark')}</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow>
                        <TableCell>{item[productInjectionFields.supplierPurchaseNumber.retrieveKey]}</TableCell>
                        <TableCell>{item[productInjectionFields.companyPurchaseNumber.retrieveKey]}</TableCell>
                        {/* <TableCell>{parseFloat(item[productInjectionFields.prepayDepositFee.retrieveKey]).toFixed(2)}</TableCell>
                        <TableCell>{parseFloat(item[productInjectionFields.prepayTransportFee.retrieveKey]).toFixed(2)}</TableCell> */}
                        <TableCell>{formatRoundValue(item[productInjectionFields.prepayDepositFee.retrieveKey], 2).toFixed(2)}</TableCell>
                        <TableCell>{formatRoundValue(item[productInjectionFields.prepayTransportFee.retrieveKey], 2).toFixed(2)}</TableCell>
                        <StyledCell colSpan={2}>
                            {/* <StyledTypography> */}
                            {item[productInjectionFields.remark.retrieveKey]}
                            {/* </StyledTypography> */}
                        </StyledCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const RenderLoadStatus = ({ t, getRoute, dataLoadStatus, dataContainer }) => {

    if (!dataLoadStatus) return <></>

    let loadedDisplay = dataLoadStatus.toLowerCase()

    loadedDisplay = t(loadedDisplay)
    loadedDisplay = loadedDisplay.toUpperCase()

    return (
        (dataLoadStatus === productLoadStatusTypes.loaded.value) ?
            <>
                <Grid item xs={12} sm={12} md={6} textAlign={"right"}>
                    <Chip
                        label={loadedDisplay}
                        color='primary'
                        variant='outlined'
                        size='small'
                        sx={{
                            width: '20%',
                            fontSize: 14,
                            fontWeight: 800
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={12}
                    sx={{
                        mt: 1
                    }}
                >
                    <TableContainer>
                        <Table
                            sx={{
                                "& .MuiTableCell-root": {
                                    border: "1px solid rgba(224, 224, 224, 1)",
                                }
                            }}
                            size="small"
                            aria-label="a dense table"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('location')}</TableCell>
                                    <TableCell>{t('destination')}</TableCell>
                                    <TableCell>{t('repositoryNo')}</TableCell>
                                    <TableCell>{t('containerMarking')}</TableCell>
                                    <TableCell>{t('alternativeNo')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{dataContainer?.location_name}</TableCell>
                                    <TableCell>{dataContainer?.to_location_name}</TableCell>
                                    <TableCell>

                                        <Link
                                            href={getRoute(`repositories/container/modify/${dataContainer?.id}`)}
                                            target="_blank"
                                        >
                                            {dataContainer?.repo_number}
                                        </Link>
                                    </TableCell>
                                    <TableCell>

                                        <Link
                                            href={getRoute(`repositories/container/modify/${dataContainer?.id}`)}
                                            target="_blank"
                                        >
                                            {dataContainer?.number_marking}
                                            {/* {JSON.stringify(dataContainer)} */}
                                        </Link>
                                    </TableCell>
                                    <TableCell>{dataContainer?.number_alternative}</TableCell>
                                </TableRow>
                            </TableBody>

                        </Table>
                    </TableContainer>
                </Grid>
            </>
            :
            <>
                <Grid item xs={12} sm={12} md={6} textAlign={"right"}>
                    <Chip
                        label={t(loadedDisplay)}
                        color='primary'
                        variant='outlined'
                        size='small'
                        sx={{
                            width: '20%',
                            fontSize: 14,
                            fontWeight: 800,

                        }}
                    />
                </Grid>
            </>
    )
}

const RenderContainerInfo = ({ t, getRoute, dataLoadStatus, dataContainer }) => {

    // if (!data?.product) return <></>

    // let item = data?.product

    return (
        // check if loadStatus === "Loaded" only show table, else show status alignment in the center with pending icon
        <StyledCard>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                    <CommonSectionHeader
                        title={t('containerInfo')}
                        subTitle={t('detailInformationAssignedToContainer')}
                    />
                </Grid>

                <RenderLoadStatus
                    t={t}
                    getRoute={getRoute}
                    dataLoadStatus={dataLoadStatus}
                    dataContainer={dataContainer}
                />


            </Grid>
        </StyledCard>
    )
}

const RenderSectionItems = ({
    t,
    totalSummary,
    editableData,
    selectedIds,
    // data,
    dataItems,

    handleChangeRowSelect,
    handleResetUpdateItem,
    handleProcessRowUpdate,
    handleUpdateItem,
    // handleDeleteItem

}) => {

    if (!dataItems) return <></>

    // const { product } = data;

    // let totalSummary = getTotalSummary()

    const RenderSummaryValueDisplay = ({ primaryValue, secondaryValue, isWordChange }) => {
        return (
            (isWordChange !== false) ?
                (<Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                >
                    <Typography
                        sx={{
                            fontSize: 20,
                            fontWeight: 800,
                            color: green[500]
                        }}
                    >
                        {primaryValue}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: 15,
                            color: grey[500],
                            ml: 1
                        }}
                    >
                        ({secondaryValue})
                    </Typography>
                </Box>)
                :
                (<Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                >
                    <Typography
                        sx={{
                            fontSize: 17,
                            fontWeight: 800,
                        }}
                    >
                        {primaryValue}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: 15,
                            color: grey[500],
                            ml: 1
                        }}
                    >
                        ({secondaryValue})
                    </Typography>
                </Box>)
        )
    }

    return (
        <Box
            sx={{
                mt: 1
            }}
        >
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={5} textAlign={"left"}>

                    <Box
                        sx={{
                            pl: 2
                        }}
                    >
                        <CommonSectionHeader
                            title={t('items')}
                            subTitle={t('detailInformationDescribedTheItems')}
                        />
                    </Box>

                </Grid>

                <Grid item xs={12} sm={12} md={7} textAlign={"right"}>

                    <Box
                        sx={{
                            pr: 2
                        }}
                    >
                        <TableContainer
                        >
                            <Table
                                // sx={{ minWidth: 650 }} 
                                sx={{
                                    "& .MuiTableCell-root": {
                                        border: "1px solid rgba(224, 224, 224, 1)",
                                        // backgroundColor: '#fff',
                                        // my: 1,
                                        p: 0,
                                        px: 1,
                                        fontSize: 13
                                    },
                                }}
                                size="small"
                                aria-label="a dense table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="right" width={"20%"}>{t('totalPackQty')}</TableCell>
                                        <TableCell align="right" width={"20%"}>{t('totalValues')}</TableCell>
                                        <TableCell align="right" width={"20%"}>{t('totalWeight')}</TableCell>
                                        <TableCell align="right" width={"20%"}>{t('totalCbm')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="right">
                                            <RenderSummaryValueDisplay
                                                primaryValue={formatRoundValue(totalSummary?.totalPackQty, 0).toFixed(0)}
                                                secondaryValue={`${totalSummary?.totalPackQty}`}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <RenderSummaryValueDisplay
                                                primaryValue={formatRoundValue(totalSummary?.totalValues, 2).toFixed(2)}
                                                secondaryValue={`${totalSummary?.totalValues}`}
                                                isWordChange={false}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <RenderSummaryValueDisplay
                                                primaryValue={formatRoundValue(totalSummary?.totalWeight, 3).toFixed(3)}
                                                secondaryValue={`${totalSummary?.totalWeight}`}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <RenderSummaryValueDisplay
                                                primaryValue={formatRoundValue(totalSummary?.totalCbm, 3).toFixed(3)}
                                                secondaryValue={`${formatRoundValue(totalSummary?.totalCbm, 4).toFixed(4)}`}
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>


                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                    {/* <RenderItems
                            data={dataItems}
                            dataProduct={data}
                        /> */}

                    {/* {JSON.stringify(editableData)} */}
                    <RenderItems
                        editableData={editableData}
                        selectedIds={selectedIds}
                        // data={dataItems}
                        // dataProduct={data}
                        onHandleChangeRowSelect={handleChangeRowSelect}
                        onResetUpdateItem={handleResetUpdateItem}
                        onProcessRowUpdate={handleProcessRowUpdate}
                        onHandleUpdateItem={handleUpdateItem}
                    // onHandleDeleteItem={handleDeleteItem}
                    />
                    {/* {
                        RenderItems({
                            editableData,
                            onResetUpdateItem: (data) => {

                                // console.log('editableData', editableData.pendingUpdate, data)

                                let checkExist = editableData.pendingUpdate.filter(i => i.id === data?.id)

                                if (checkExist.length > 0) {

                                    let newPendingUpdates = editableData.pendingUpdate.filter(i => i.id !== data?.id)

                                    setEditableData({
                                        ...editableData,
                                        pendingUpdate: newPendingUpdates
                                    })

                                } else {
                                    promptMessage(false, `Unfound itemId: ${data?.id} in states`)
                                }

                            },
                            onProcessRowUpdate: (data) => {

                                setEditableData({
                                    ...editableData,
                                    pendingUpdate: data
                                })
                            },
                            onHandleUpdateItem: (itemId, productId) => {
                                handleEditProductItem({ itemId, productId })
                            },
                            onHandleDeleteItem: async (itemId, data) => {

                                if (dataItems.length <= 1) {
                                    promptMessage(false, `Min at least 1 item`)
                                    return false
                                }

                                let checkExist = await fetchItem(itemId)

                                let checkExistItems = checkExist?.item ? checkExist.item : {}

                                // check the source remId is exist
                                let checkExistItemsSourceRemId = checkExistItems[itemInjectionFields.sourceItemRemId.retrieveKey]

                                // console.log('checkExistItemsSourceRemId', checkExistItemsSourceRemId)

                                if (!checkExistItemsSourceRemId) {
                                    promptMessage(false, `The item is not yet ready for delete [sourceRemId are empty]`)
                                    return false;
                                }

                                setActionConfirmProps({
                                    ...actionConfirmProps,
                                    open: true,
                                    title: t('removeItem'),
                                    renderBody: () => {
                                        return (
                                            <Typography>
                                                {t('areYouSureToDeleteThisItem')}
                                            </Typography>
                                        )
                                    },
                                    handleConfirm: () => {
                                        handleItemDelete({ data })
                                    }
                                })

                                return true

                            },
                            selectedIds,
                            onHandleChangeRowSelect: (ids) => {
                                setSelectedIds(ids)
                            },
                            data: dataItems,
                            dataProduct: data
                        })
                    } */}
                </Grid>

            </Grid>
        </Box>
    )
}

export default function UpdateProduct({
    routeType
}) {

    const { t } = useTranslations({ ns: ["_@products", "_@repositories", "_@report", "_prompt", "common", "_common"] })

    const { id } = useParams();

    const { authData } = useAuthAccess(routeType)

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.product.id, scopeTypes.product.product.id)

    // let authProfileUserId = authData?.profile?.user?.id

    const {
        // getProductItem,
        addProductItemBatch,
        updateProductItem,
        listProductItems,
        removeProductItems,
        filterOperatorTypes
    } = useProductItem({ routeType })

    const {
        getProduct,
        listProducts,
        updateLastUpdateProduct,
        checkProductIsLoadedContainer
    } = useProduct({ routeType })

    const { updateContainerSummary } = useContainerSummary({ routeType })

    const { getContainer } = useContainer({ routeType })

    const {
        list: listFiles,
    } = useFiles({ targetType: fileTargetTypes.file })

    const [actionConfirmProps, setActionConfirmProps] = useState({
        open: false,
        title: ``,
        renderBody: () => { return <></> },
        handleConfirm: () => { }
    })

    const [openDialog, setOpenDialog] = useState({
        status: false,
        title: t("addItems"),
        productIndex: 0,
        courierTrackingNo: ``,
        data: {}
    })

    const [openItemV1Dialog, setOpenItemV1Dialog] = useState({
        status: false,
        title: t("addItems"),
        productIndex: 0,
        courierTrackingNo: ``,
        data: {}
    })

    const tableVersionTypes = {
        tableGridV1: {
            id: 'gridV1',
            display: 'tableGridV1'
        },
        tableGridV2: {
            id: 'gridV2',
            display: 'tableGridV2'
        }
    }

    const navigate = useNavigate();

    // const [inputDisabled, setInputDisabled] = useState(false)

    const [data, setData] = useState()
    const [dataItems, setDataItems] = useState([])
    const [dataContainer, setDataContainer] = useState()
    const [dataLoadStatus, setDataLoadStatus] = useState()
    const [dataNfc, setDataNfc] = useState({})
    const [dataFiles, setDataFiles] = useState({
        nfc: [],
        gallery: []
    })

    const [selectedIds, setSelectedIds] = useState([])

    const [editableData, setEditableData] = useState({
        items: [],
        pendingUpdate: [],
        total: {}
    })

    const [selectedOption, setSelectedOption] = useState('');
    const [selectedFabGridTable, setSelectedFabGridTable] = useState('');

    const authDataUserId = `${authData?.profile?.user?.id}`
    const authDataUserDisplay = `${authData?.profile?.user?.username}`

    const loadData = async (id) => {

        setSystemLoading(true);

        try {

            let dataTypesArray = [`${getInjectionDataType('product')}`]

            const data = await getProduct({ id, dataTypesArray })

            const { items, product } = data

            let itemIds = items.map(i => i.id)

            // console.log('data-->', data)

            setData(data)

            let _items = []

            if (itemIds.length > 0) {
                _items = await fetchItems({ itemIds })
            } else {
                setEditableData({
                    ...editableData,
                    items: [],
                    total: {}
                })
            }

            // if have container assigned
            let containerId = product[productInjectionFields.loadContainerId.retrieveKey]
            let loadStatus = product[productInjectionFields.loadStatus.retrieveKey]

            setDataLoadStatus(loadStatus)

            // if (loadStatus === productLoadStatusTypes.loaded.value) {
            //     setInputDisabled(true)
            // }

            setDataNfc({
                fileId: product[productInjectionFields.nfcFileId.retrieveKey],
                identityNo: product[productInjectionFields.nfcIdentityNo.retrieveKey]
            })

            if (loadStatus === productLoadStatusTypes.loaded.value) {
                if (containerId !== "" && containerId !== 0) {

                    const _dataContainer = await getContainer({ id: containerId, dataTypesArray: [`${getInjectionDataType('container')}`] })

                    // await fetchContainer({ containerId })

                    setDataContainer(_dataContainer?.repository ? _dataContainer.repository : {})
                }
            }

            // get the files related to this product
            let allFiles = await fetchAllFiles({ referId: id })

            // console.log('allFiles', allFiles)

            setDataFiles({
                nfc: allFiles.filter(i => i.type.toUpperCase() === productImageTypes.nfcImage.typeValue.toUpperCase()),
                gallery: allFiles.filter(i => i.type.toUpperCase() === productImageTypes.galleryImages.typeValue.toUpperCase())
            })

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)
        return false

    }

    const onSubmitCreateItems = async ({ productId, items }) => {

        setSystemLoading(true)

        try {

            let dataProduct = data?.product ? data.product : {}

            let courierTrackingNo = dataProduct[productInjectionFields.courierTrackingNo.retrieveKey]
            // let marking = dataProduct[productInjectionFields.customerMarking.retrieveKey]
            let sourceProductRemId = dataProduct[productInjectionFields.sourceProductRemId.retrieveKey]
            let registerLocationId = dataProduct[productInjectionFields.registerLocationId.retrieveKey]
            let customerMarking = dataProduct[productInjectionFields.customerMarking.retrieveKey]
            let customerBranchId = dataProduct[productInjectionFields.customerBranchId.retrieveKey]
            let customerUserId = dataProduct[productInjectionFields.customerUserId.retrieveKey]

            let submitItems = []

            let shortenCourierTrackingNo = courierTrackingNo

            // shorten the tracking no - to first 14 digit
            if (courierTrackingNo.length >= 14) {
                shortenCourierTrackingNo = courierTrackingNo.substring(0, 14)
            }

            // console.log('items', items)

            items.forEach((i, indexno) => {

                let _code = getUniqueItemCode({ courierTrackingNo: `${shortenCourierTrackingNo}_${indexno}`, productId })

                let _cbm = parseFloat(i?.cbm)
                let _totalWeight = parseFloat(i?.totalWeight)
                let _totalValue = parseFloat(i?.totalValue)
                let _totalCbm = parseFloat(i?.totalCbm)
                let _qty = parseFloat(i?.qty).toFixed(0)
                // Keep the decimals: totalValue was worked out from the typed qty, so rounding here
                // saved 26 next to a value for 25.8 and the goods total stopped adding up.
                let _handleQty = parseFloat(i?.handleQty).toFixed(4)
                let _handleQtyPerPackage = parseFloat(i?.handleQtyPerPackage).toFixed(0)

                let _width = i?.width
                let _length = i?.length
                let _height = i?.height
                let _weight = i?.weight
                let _uomPrice = i?.uomPrice

                let _desc = i?.description
                let _remark = i?.remark

                let newItems = {
                    productId,
                    code: _code,
                    uomId: defaultUom.id,
                    // uomName: defaultUom.uomName,
                    uomName: t(defaultUom.value),
                    customUomName: i?.customUomName,
                    uomPrice: _uomPrice,
                    remark: _remark,
                    netWeight: _weight,
                    itemDescription: _desc,
                    width: _width,
                    height: _height,
                    length: _length,
                    cbm: _cbm,

                    qty: _qty,
                    handleQty: _handleQty,
                    handleQtyPerPackage: _handleQtyPerPackage,
                    totalValue: _totalValue,
                    totalCbm: _totalCbm,
                    totalWeight: _totalWeight,

                }

                submitItems.push(newItems)

                items[indexno]._code = _code

            })

            let payload = {
                sourceProductRemId,
                registerLocationId,
                customerMarking,
                customerBranchId,
                customerUserId,
                data: submitItems
            }

            // console.log('payload', payload)

            const response = await addProductItemBatch(payload)

            let _p = {
                productId,
                lastUpdateUserId: authDataUserId,
                lastUpdateUserDisplay: authDataUserDisplay
            }

            await updateLastUpdateProduct(_p)

            // check product loaded to container
            let responseLoadedContainer = await checkProductIsLoadedContainer({ productId: id })

            let loadContainerId = responseLoadedContainer?.loadContainerId
            let loadContainerStatus = responseLoadedContainer?.loadContainerStatus

            if (loadContainerStatus === productLoadStatusTypes.loaded.id) {
                updateContainerSummary({ containerId: loadContainerId, listProducts })
            }

            setSystemLoading(false)

            loadData(id);

            promptMessage(true, `${t('successfullyAdded')} ${submitItems.length} ${t('items')}`)

        } catch (error) {

            promptMessage(false, `${error?.message}`)

        }

        setSystemLoading(false)

        return true
    }

    const parseDataItems = ({ items }) => {

        let total = {
            weight: 0,
            cbm: 0,
            value: 0,
            packQty: 0
        }

        let showItems = []

        // summary
        items.forEach((row, index2) => {

            // console.log('row', row)

            let model = row?.item_remark
            let description = row?.item_description

            let packQty = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.packQty.retrieveKey) ? row[itemInjectionFields.packQty.retrieveKey] : 0
            let handleQty = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.handleQty.retrieveKey) ? row[itemInjectionFields.handleQty.retrieveKey] : 0
            let qtyPerPackage = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.qtyPerPackage.retrieveKey) ? row[itemInjectionFields.qtyPerPackage.retrieveKey] : 0
            // let dimensionWidth = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.width.retrieveKey) ? row[itemInjectionFields.width.retrieveKey] : 0
            // let dimensionHeight = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.height.retrieveKey) ? row[itemInjectionFields.height.retrieveKey] : 0
            // let dimensionLength = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.length.retrieveKey) ? row[itemInjectionFields.length.retrieveKey] : 0
            let totalValue = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.totalValue.retrieveKey) ? row[itemInjectionFields.totalValue.retrieveKey] : 0
            let totalWeight = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.totalWeight.retrieveKey) ? row[itemInjectionFields.totalWeight.retrieveKey] : 0
            let totalCbm = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.totalCbm.retrieveKey) ? row[itemInjectionFields.totalCbm.retrieveKey] : 0
            let uomName = Object.prototype.hasOwnProperty.call(row, itemInjectionFields.uomName.retrieveKey) ? row[itemInjectionFields.uomName.retrieveKey] : 0

            let dimensionWidth = row?.dimension_width
            let dimensionHeight = row?.dimension_height
            let dimensionLength = row?.dimension_length

            // filter null uom
            if (!uomName) {
                let defaultUom = supportedItemUoms.filter(i => i.isDefault === true)
                if (defaultUom.length > 0) {
                    // uomName = defaultUom[0]?.value
                    uomName = t(defaultUom[0]?.value)
                }
            } else {
                // let uomValue = ''

                // getting the uom name
                let a = supportedItemUoms.filter(i => i.translation.includes(uomName) === true)

                if (a.length > 0) {

                    // console.log('a[0].value', a[0].value)

                    uomName = t(a[0].display)
                }
            }

            // console.log('totalCbm', totalCbm)

            packQty = parseFloat(packQty).toFixed(0)
            // handleQty = parseFloat(handleQty).toFixed(0)
            handleQty = parseFloat(handleQty)
            qtyPerPackage = parseFloat(qtyPerPackage).toFixed(0)
            dimensionWidth = parseFloat(dimensionWidth).toFixed(2)
            dimensionHeight = parseFloat(dimensionHeight).toFixed(2)
            dimensionLength = parseFloat(dimensionLength).toFixed(2)
            totalValue = parseFloat(totalValue).toFixed(2)
            totalWeight = parseFloat(totalWeight).toFixed(4)
            totalCbm = parseFloat(totalCbm).toFixed(4)

            let uomPrice = row?.uom_price ? parseFloat(row.uom_price).toFixed(2) : 0
            // let qty = row?.qty ? parseFloat(row.qty).toFixed(0) : 0
            let cbm = row?.cbm ? parseFloat(row.cbm).toFixed(4) : 0
            let weight = row?.net_weight ? parseFloat(row.net_weight).toFixed(4) : 0

            // console.log('net_weight', row.net_weight, weight)

            total.weight += parseFloat(totalWeight)
            total.cbm += parseFloat(totalCbm)
            total.value += parseFloat(totalValue)
            total.packQty += parseFloat(packQty)

            showItems.push({
                ...row,
                _item_remark: model,
                _item_description: description,
                _uom_price: uomPrice,
                _cbm: cbm,
                _weight: weight,
                _uom_name: uomName,
                _pack_qty: packQty,
                _handle_qty: handleQty,
                _qty_per_package: qtyPerPackage,
                _dimension_width: dimensionWidth,
                _dimension_height: dimensionHeight,
                _dimension_length: dimensionLength,
                _total_value: totalValue,
                _total_weight: totalWeight,
                _total_cbm: totalCbm
            })
        })

        // setShowItems(showItems)
        return {
            showItems,
            total
        }
    }

    const fetchItems = async ({ itemIds, overrideEditableStates = true }) => {

        try {

            let props = {
                limit: -1,
                skip: 0,
                filterValue: [],
                sortInfo: {
                    id: "id",
                    dir: 0
                }
            }

            const { data } = await listProductItems({ props, itemIds, dataTypes: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`] })

            // let _items = result?.data?.items ? result.data.items : []
            let _items = data

            // console.log('_items 111 ', JSON.stringify(_items))
            // console.log('datadata', JSON.stringify(data))

            setDataItems(_items)

            if (overrideEditableStates) {
                let { showItems, total } = parseDataItems({ items: _items })

                // console.log('showItems', _items, showItems)

                setEditableData({
                    ...editableData,
                    pendingUpdate: [],
                    items: showItems,
                    total
                })
            }

            return _items

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        return false

    }

    const fetchAllFiles = async ({ referId }) => {

        try {

            let filterValues = [];

            filterValues.push({
                name: "module",
                operator: filterOperatorTypes.eq,
                value: fileModuleTypes.item.product.value,
            })

            filterValues.push({
                name: "file_ref",
                operator: filterOperatorTypes.eq,
                value: fileReferenceTypes.item.product.value,
            })

            // filterValues.push({
            //     name: "type",
            //     operator: filterOperatorTypes.eq,
            //     value: productImageTypes.nfcImage.typeValue,
            // })

            // filterValues.push({
            //     name: "tag",
            //     operator: filterOperatorTypes.eq,
            //     value: productImageTypes.nfcImage.tagValue,
            // })

            filterValues.push({
                name: "refer_id",
                operator: filterOperatorTypes.eq,
                value: referId,
            })

            const props = {
                limit: -1,
                offset: 0,
                filterValue: filterValues,
                sortInfo: {
                    id: "id",
                    dir: 0,
                }
            }

            const result = await listFiles(props)

            return result?.data?.files ? result.data.files : []

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

        }

        return []

    }

    useEffect(() => {

        loadData(id);

    }, [])

    const getTotalSummary = () => {

        let totalPackQty = 0
        let totalValues = 0
        let totalWeight = 0
        let totalCbm = 0

        editableData?.items.forEach(i => {
            totalPackQty += parseFloat(i[itemInjectionFields.packQty.retrieveKey])
            totalValues += parseFloat(i[itemInjectionFields.totalValue.retrieveKey])
            totalWeight += parseFloat(i[itemInjectionFields.totalWeight.retrieveKey])
            totalCbm += parseFloat(i[itemInjectionFields.totalCbm.retrieveKey])
        })

        return {
            totalPackQty,
            totalValues,
            totalWeight,
            totalCbm
        }

    }

    const handleIndentityInfo = () => {
        openCustomDrawer({
            show: true,
            anchor: "right",
            title: t('mainlandIdentityCard'),
            PaperProps: {
                sx: { width: 2 / 3 }
            },
            handleOnClose: () => {
                loadData(id)
            },
            ComponentActions:
                <></>,
            ComponentBody:

                <UpdateProductIdentity
                    id={id}
                    routeType={routeType}
                    handleOnSuccess={() => {
                        closeCustomDrawer()
                    }}
                />
        })

        return true;
    }

    const handleProductImages = () => {
        openCustomDrawer({
            show: true,
            anchor: "right",
            title: t('updateProductImages'),
            PaperProps: {
                sx: { width: 2 / 3 }
            },
            handleOnClose: () => {
                loadData(id)
            },
            ComponentActions:
                <></>,
            ComponentBody:

                <UpdateProductImages
                    id={id}
                    routeType={routeType}
                    handleOnSuccess={() => {
                        closeCustomDrawer()
                        loadData(id)
                    }}
                />
        })

        return true;
    }

    // delete
    // const handleItemDelete = async ({ data }) => {

    //     setSystemLoading(true)

    //     try {

    //         let sourceItemRemId = ``;// data[itemInjectionFields.sourceItemRemId.retrieveKey]

    //         if (!sourceItemRemId) {
    //             throw Error(`sourceItemRemId is Required`)
    //         }

    //         let ids = [data?.id]

    //         // let response = await removeItem({ ids, itemType: itemTypes.item })
    //         let response = await removeProductItems({ ids })
    //         // getSavedRate(id)

    //         let _p = {
    //             productId: id,
    //             lastUpdateUserId: authDataUserId,
    //             lastUpdateUserDisplay: authDataUserDisplay
    //         }

    //         await updateLastUpdateProduct(_p)

    //         promptMessage(true, `${response?.message}`)

    //         loadData(id)

    //     } catch (error) {
    //         promptMessage(false, `${error?.message}`)
    //     }

    //     setSystemLoading(false)

    // }

    const handleBulkItemsDelete = async ({ itemIds }) => {

        setSystemLoading(true)

        let countSuccess = 0
        let countFailed = 0

        // check all the related item source remid - temp off
        // let emptySourceItemRemIdItems = dataItems.filter(i => !i[itemInjectionFields.sourceItemRemId.retrieveKey])

        // console.log('emptySourceItemRemIdItems', emptySourceItemRemIdItems)

        // if (emptySourceItemRemIdItems.length > 0) {
        // if (false) {
        //     promptMessage(false, `There are (${emptySourceItemRemIdItems.length}) sourceItemRemId are empty`)
        //     return false;
        // } else {

        await Promise.all(itemIds.map(async (id) => {

            let ids = [id]

            // let response = await removeItem({ ids, itemType: itemTypes.item })
            let response = await removeProductItems({ ids })

            if (response?.status) {
                countSuccess += 1
            } else {
                countFailed += 1
            }

        }));

        // check product loaded to container
        let responseLoadedContainer = await checkProductIsLoadedContainer({ productId: id })

        let loadContainerId = responseLoadedContainer?.loadContainerId
        let loadContainerStatus = responseLoadedContainer?.loadContainerStatus

        if (loadContainerStatus === productLoadStatusTypes.loaded.id) {
            updateContainerSummary({ containerId: loadContainerId, listProducts })
        }

        let _p = {
            productId: id,
            lastUpdateUserId: authDataUserId,
            lastUpdateUserDisplay: authDataUserDisplay
        }

        await updateLastUpdateProduct(_p)

        if (countFailed > 0) {
            promptMessage(false, `${t('deleted')} (${countSuccess}) ${t('success')} / (${countFailed}) ${t('failed')}`)
        } else {
            promptMessage(false, `${t('deleted')} (${countSuccess}) ${t('success')}`)
        }

        // }

        setSystemLoading(false)

        return true

    }

    const handleEditProduct = ({ productId }) => {

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: t('updateProduct'),
            PaperProps: {
                sx: { width: 5 / 6 }
            },
            handleOnClose: () => {

            },
            ComponentActions:
                <>
                    {/* <Button
                        variant="contained"
                        // color={"primary"}
                        size="small"
                        onClick={() => openNew({ row, rackData })}
                    >
                        New Validation
                    </Button> */}
                </>,
            ComponentBody:
                <>
                    <UpdateProductMain
                        routeType={routeType}
                        productId={productId}
                        handleOnSuccess={() => {
                            closeCustomDrawer();
                            loadData(id)
                        }}
                    />
                </>
        })
    }

    // open dialog
    const handleAddProductItem = ({ productId }) => {

        // console.log('data?.product[productInjectionFields.sourceProductRemId.retrieveKey]', data?.product[productInjectionFields.sourceProductRemId.retrieveKey])

        if (data?.product[productInjectionFields.sourceProductRemId.retrieveKey]) {
            setOpenDialog({
                ...openDialog,
                status: true,
                title: `${t('addItems')}`,
                productIndex: 0,
                courierTrackingNo: data?.product[productInjectionFields.courierTrackingNo.retrieveKey],
                data: ``
            })
            setSelectedFabGridTable(tableVersionTypes.tableGridV2.id)

            return false
        }

        promptMessage(false, `Source Product RemId is empty`)
        return false

    }

    const handleAddProductItemV1 = ({ productId }) => {

        if (data?.product[productInjectionFields.sourceProductRemId.retrieveKey]) {
            setOpenItemV1Dialog({
                ...openItemV1Dialog,
                status: true,
                title: `${t('addItems')}`,
                productIndex: 0,
                courierTrackingNo: data?.product[productInjectionFields.courierTrackingNo.retrieveKey],
                data: ``
            })
            setSelectedFabGridTable(tableVersionTypes.tableGridV1.id)

            return false
        }

        promptMessage(false, `Source Product RemId is empty`)
        return false

    }

    // open dialog
    const handleEditProductItem = ({ itemId, productId }) => {

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: t('updateProductItem'),
            PaperProps: {
                sx: { width: 5 / 6 }
            },
            handleOnClose: () => {

            },
            ComponentActions:
                <>
                    {/* <Button
                        variant="contained"
                        // color={"primary"}
                        size="small"
                        onClick={() => openNew({ row, rackData })}
                    >
                        New Validation
                    </Button> */}
                </>,
            ComponentBody:
                <>
                    <UpdateProductItem
                        routeType={routeType}
                        itemId={itemId}
                        productId={productId}
                        handleOnSuccess={() => {
                            closeCustomDrawer();
                            loadData(id)
                        }}
                    />
                </>
        })
    }

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id })) {
        //     props.push({
        //         displayText: "Edit Item",
        //         href: getRoute(`product/item/update/${id}`),
        //     })
        // }

        return props

    }

    const handleDeleteBulkItems = async ({ itemIds }) => {

        setSystemLoading(true);

        if (itemIds.length < 1) {
            promptMessage(false, `${t('minAtLeast1Item')}`)
            return false
        }

        let checkItems = await fetchItems({ itemIds, overrideEditableStates: false })

        // console.log('checkItems', checkItems)

        let checkAllSourceRemIdExist = true

        checkItems.forEach(i => {

            let sourceRemId = i[itemInjectionFields.sourceItemRemId.retrieveKey]

            console.log('sourceRemId', sourceRemId, i)

            if (sourceRemId === "" || sourceRemId === "NULL" || sourceRemId == null) {
                checkAllSourceRemIdExist = false
            }

        })

        // let checkExistItems = checkExist?.item ? checkExist.item : {}

        // // check the source remId is exist
        // let checkExistItemsSourceRemId = checkExistItems[itemInjectionFields.sourceItemRemId.retrieveKey]

        // // console.log('checkExistItemsSourceRemId', checkExistItemsSourceRemId)

        if (!checkAllSourceRemIdExist) {
            setSystemLoading(false);
            promptMessage(false, `someOfItemsHasNotSyncFinished`)
            return false;
        }

        setActionConfirmProps({
            ...actionConfirmProps,
            open: true,
            title: t('removeItem'),
            renderBody: () => {
                return (
                    <Typography>
                        {t('areYouSureToDeleteThisItem')}
                    </Typography>
                )
            },
            handleConfirm: async () => {
                await handleBulkItemsDelete({ itemIds })
                loadData(id)
            }
        })

        setSystemLoading(false);

        return true
    }

    const handleUpdateBulkItems = async () => {

        const _pendingUpdates = editableData?.pendingUpdate

        console.log('_pendingUpdates', _pendingUpdates)

        if (_pendingUpdates.length <= 0) {
            promptMessage(false, `${t('minSelectOneItem')}`)
            return false
        }

        let isInvalidSource = false

        // check source remid must valid bulk
        _pendingUpdates.forEach(i => {
            let sourceRemId = i[itemInjectionFields.sourceItemRemId.retrieveKey]
            // console.log('sourceRemId', sourceRemId)

            if (!sourceRemId) {
                isInvalidSource = true
            }
        })

        if (isInvalidSource === true) {
            promptMessage(false, `One of the items invalid source remid`)
            return false;
        }

        setSystemLoading(true)

        /** update api bulk  */
        let updateFailResponses = []

        // let _updateInjectionProps = []

        let itemIds = editableData.items.map(i => i.id)

        await Promise.all(_pendingUpdates.map(async (i) => {

            let itemId = i?.id

            // let _cbm = i?._cbm // need calculate cbm

            let _code = i?.code
            let _width = parseFloat(i?._dimension_width)
            let _height = parseFloat(i?._dimension_height)
            let _length = parseFloat(i?._dimension_length)
            // net_weight is stored at 4dp, so the total must derive from that same value
            let _weight = formatRoundValue(parseFloat(i?._weight), 4)
            let _uomPrice = parseFloat(i?._uom_price)
            let _uomName = i?._uom_name

            // console.log('width', _width, _height, _length, i)

            let _cbm = calculateCbmByDimension({ w: _width, h: _height, l: _length })

            let _packQty = i?._pack_qty
            let _qtyPerPackage = i?._qty_per_package
            let _handleQty = i?._handle_qty
            let _totalValue = _handleQty * _uomPrice
            let _totalWeight = _weight * _packQty
            let _totalCbm = _cbm * _packQty

            try {

                let payload = {
                    itemId,
                    productId: id,
                    sourceItemRemId: i[itemInjectionFields.sourceItemRemId.retrieveKey],
                    registerLocationId: data[productInjectionFields.registerLocationId.retrieveKey],
                    item: {
                        userMarking: i[itemInjectionFields.customerMarking.retrieveKey],
                        userBranchId: i[itemInjectionFields.customerBranchId.retrieveKey],
                        userId: i[itemInjectionFields.customerUserId.retrieveKey],
                        code: _code,
                        uomId: i?.uom_id,
                        itemDescription: i?._item_description,
                        remark: i?._item_remark,
                        uomPrice: _uomPrice,
                        netWeight: _weight.toFixed(4),
                        width: _width.toFixed(2),
                        height: _height.toFixed(2),
                        length: _length.toFixed(2),

                        qty: _packQty,
                        handleQty: _handleQty,
                        handleQtyPerPackage: _qtyPerPackage,
                        uomName: _uomName,

                        cbm: _cbm, // need recalculate the new cbm
                        totalWeight: _totalWeight,
                        totalValue: _totalValue,
                        totalCbm: _totalCbm
                    },
                    skipTargetInjectionPropIds: [],
                    targetInjectionPropIds: [
                        "packQty",
                        "handleQty",
                        "qtyPerPackage",
                        "uomName",
                        "totalValue",
                        "totalCbm",
                        "totalWeight"
                    ],
                }

                // console.log('payload', JSON.stringify(payload))
                // console.log('data1', JSON.stringify(data1))

                let responseUpdateItem = await updateProductItem(payload)

                // check product loaded to container
                let response = await checkProductIsLoadedContainer({ productId: id })

                // console.log('response', response)

                let loadContainerId = response?.loadContainerId
                let loadContainerStatus = response?.loadContainerStatus

                if (loadContainerStatus === productLoadStatusTypes.loaded.id) {
                    updateContainerSummary({ containerId: loadContainerId, listProducts })
                }


            } catch (error) {

                console.error(`Error: `, error)
                updateFailResponses.push(error)
            }

        }));

        if (updateFailResponses.length > 0) {
            promptMessage(false, `${updateFailResponses.length} ${t('failedToUpdate')}`)
        }

        let _p = {
            productId: id,
            lastUpdateUserId: authDataUserId,
            lastUpdateUserDisplay: authDataUserDisplay
        }

        await updateLastUpdateProduct(_p)

        // reset and refetch the data
        await fetchItems({
            itemIds,
            overrideEditableStates: true,
            // onSuccessCallback: () => {
            //     setEditableData({
            //         ...editableData,
            //         pendingUpdate: []
            //     })
            // }
        })

        setSystemLoading(false)

        promptMessage(true, `${t('savedSuccess')}`)

        return true

    }

    const handleChangeRowSelect = (ids) => {
        setSelectedIds(ids)
    }

    const handleResetUpdateItem = (data) => {

        // console.log('editableData', editableData.pendingUpdate, data)

        let checkExist = editableData.pendingUpdate.filter(i => i.id === data?.id)

        if (checkExist.length > 0) {

            let newPendingUpdates = editableData.pendingUpdate.filter(i => i.id !== data?.id)

            setEditableData({
                ...editableData,
                pendingUpdate: newPendingUpdates
            })

        } else {
            promptMessage(false, `Unfound itemId: ${data?.id} in states`)
        }

    }

    const handleProcessRowUpdate = (data) => {

        setEditableData({
            ...editableData,
            pendingUpdate: data
        })
    }

    const handleUpdateItem = (itemId, productId) => {
        handleEditProductItem({ itemId, productId })
    }

    // const handleDeleteItem = async (itemId, data) => {

    //     if (dataItems.length <= 1) {
    //         promptMessage(false, `Min at least 1 item`)
    //         return false
    //     }

    //     const checkExist = await getProductItem({ id, dataTypesArray: [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`] })

    //     let checkExistItems = checkExist?.item ? checkExist.item : {}

    //     // check the source remId is exist
    //     let checkExistItemsSourceRemId = checkExistItems[itemInjectionFields.sourceItemRemId.retrieveKey]

    //     // console.log('checkExistItemsSourceRemId', checkExistItemsSourceRemId)

    //     if (!checkExistItemsSourceRemId) {
    //         promptMessage(false, `The item is not yet ready for delete [sourceRemId are empty]`)
    //         return false;
    //     }

    //     setActionConfirmProps({
    //         ...actionConfirmProps,
    //         open: true,
    //         title: t('removeItem'),
    //         renderBody: () => {
    //             return (
    //                 <Typography>
    //                     {t('areYouSureToDeleteThisItem')}
    //                 </Typography>
    //             )
    //         },
    //         handleConfirm: () => {
    //             handleItemDelete({ data })
    //         }
    //     })

    //     return true

    // }

    let printPackQty = 0

    if (data?.product) {
        printPackQty = parseFloat(data?.product[productInjectionFields.appPrintPackQty.retrieveKey]).toFixed(0)
    }

    // console.log('printPackQty>>>', printPackQty)

    return (
        <Box
            sx={{
                mb: 20
            }}
        >
            {
                getHtmlHead({ routeType, title: headTitles.viewItem })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('updateProduct')}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t('products'),
                        props: {
                            href: getRoute("products/items")
                        }
                    },
                    {
                        displayText: `${t('updateProduct')} (*)`,
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                    (
                        <Grid container spacing={1} textAlign={"left"}>
                            <Grid item xs={12} sm={12} md={12}>
                                <RenderSectionProduct
                                    t={t}
                                    productId={id}
                                    data={data}
                                    dataFiles={dataFiles}
                                    dataNfc={dataNfc}
                                    handleProductImages={handleProductImages}
                                    handleIndentityInfo={handleIndentityInfo}
                                    handleEditProduct={handleEditProduct}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <RenderContainerInfo
                                    t={t}
                                    getRoute={getRoute}
                                    dataLoadStatus={dataLoadStatus}
                                    dataContainer={dataContainer}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>

                                <RenderSectionItems
                                    t={t}
                                    totalSummary={getTotalSummary()}
                                    editableData={editableData}
                                    selectedIds={selectedIds}
                                    data={data}
                                    dataItems={dataItems}

                                    handleChangeRowSelect={handleChangeRowSelect}
                                    handleResetUpdateItem={handleResetUpdateItem}
                                    handleProcessRowUpdate={handleProcessRowUpdate}
                                    handleUpdateItem={handleUpdateItem}
                                // handleDeleteItem={handleDeleteItem}
                                />
                            </Grid>

                            {/* Updated */}
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12} textAlign={"center"}>
                                    <Button
                                        type="button"
                                        // fullWidth
                                        variant="contained"
                                        sx={{
                                            mt: 2,
                                            mb: 2
                                        }}
                                        // onClick={() => navigate(-1)}
                                        onClick={() => navigate(getRoute("products/items"))} // in Listing Page apply (Link: target _blank) method have to use navigate directory
                                    >
                                        {t('back')}
                                    </Button>
                                </Grid>
                            </Grid>

                        </Grid>
                    )
                    :
                    <CommonRestricted />
            }

            <ActionConfirm
                open={actionConfirmProps.open}
                handleClose={() => setActionConfirmProps({ ...actionConfirmProps, open: false })}
                handleConfirm={() => {
                    actionConfirmProps.handleConfirm()
                    setActionConfirmProps({ ...actionConfirmProps, open: false })
                }}
                config={{
                    title: actionConfirmProps.title,
                    renderBody: actionConfirmProps.renderBody,
                    cancelButtonTitle: t('cancel'),
                    confirmButtonTitle: t('yesIveConfirmed'),
                    confirmButtonProps: {
                        variant: `contained`,
                        color: 'error'
                    }
                }}
            />

            {
                (selectedFabGridTable === tableVersionTypes.tableGridV2.id) ?
                    <CommonDialog
                        open={openDialog?.status}
                        handleOnExit={(event, reason) => {

                            if (reason === `backdropClick`) {
                                return false
                            }

                            setOpenDialog({ ...openDialog, status: false, data: {} })

                            return true
                            // closeCustomDrawer()
                            // setRefreshDataGrid(val => val + 1)

                        }}
                        handleOnSelect={(value) => {
                            setSelectedOption(value)
                        }}
                        tableVersionTypes={tableVersionTypes}
                        selectedOption={selectedOption}
                        // t={t}
                        configs={{
                            data: openDialog?.data,
                            dialogProps: {
                                maxWidth: 'xl',
                            },
                            RenderDialogTitle: ({ data }) => {

                                return (
                                    <Typography
                                        sx={{
                                            fontWeight: '800'
                                        }}
                                    >
                                        {`${openDialog?.title}`}
                                    </Typography>
                                )
                            },
                            RenderDialogContent: ({ data }) => {
                                return (
                                    <Box sx={{ p: 2, }}>
                                        <AddProductItemsV2
                                            // documentId={data?.id}
                                            productId={id}
                                            productIndex={openDialog?.productIndex}
                                            courierTrackingNo={openDialog?.courierTrackingNo}
                                            currentData={openDialog?.data}
                                            allowDeleteFirstRowAfterSave={Boolean(true)}
                                            printPackQtyValue={printPackQty}
                                            onSaveSuccess={async (currentValues, productIndex, totalSummary, isDeleteFirstRowOfSavedItems) => {

                                                setOpenDialog({ ...openDialog, status: false, data: {} })

                                                // console.log('currentValues', currentValues, totalSummary)

                                                // setFieldValue(
                                                //     `products.${productIndex}.total`,
                                                //     {
                                                //         ...initialProductValues.total,
                                                //         cbm: totalSummary?.cbm,
                                                //         weight: totalSummary?.weight,
                                                //         value: totalSummary?.value
                                                //     }
                                                // )
                                                // setFieldValue(`products.${productIndex}.items`, currentValues?.items)

                                                await onSubmitCreateItems({ productId: id, items: currentValues?.items })

                                                if (isDeleteFirstRowOfSavedItems === true) {
                                                    // console.log('need to delete first row', dataItems)

                                                    let firstItemId = dataItems.length > 0 ? dataItems[0]?.id : ""

                                                    if (!firstItemId) {
                                                        promptMessage(false, `${t("failedToDeleteTheFirstRowOfSavedItems")}`)
                                                    }

                                                    await handleBulkItemsDelete({ itemIds: [firstItemId] })

                                                }

                                            }}
                                        />

                                    </Box>
                                )
                            }
                        }}
                    />
                    :
                    <CommonDialog
                        open={openItemV1Dialog?.status}
                        handleOnExit={(event, reason) => {

                            if (reason === `backdropClick`) {
                                return false
                            }

                            setOpenItemV1Dialog({ ...openItemV1Dialog, status: false, data: {} })

                            return true
                            // closeCustomDrawer()
                            // setRefreshDataGrid(val => val + 1)

                        }}
                        handleOnSelect={(value) => {
                            setSelectedOption(value)
                        }}
                        tableVersionTypes={tableVersionTypes}
                        selectedOption={selectedOption}
                        // t={t}
                        configs={{
                            data: openItemV1Dialog?.data,
                            dialogProps: {
                                maxWidth: 'xl',
                            },
                            RenderDialogTitle: ({ data }) => {

                                return (
                                    <Typography
                                        sx={{
                                            fontWeight: '800'
                                        }}
                                    >
                                        {`${openItemV1Dialog?.title}`}
                                    </Typography>
                                )
                            },
                            RenderDialogContent: ({ data }) => {
                                return (
                                    <Box sx={{ p: 2, }}>
                                        <AddProductItems
                                            // documentId={data?.id}
                                            productId={id}
                                            productIndex={openItemV1Dialog?.productIndex}
                                            courierTrackingNo={openItemV1Dialog?.courierTrackingNo}
                                            currentData={openItemV1Dialog?.data}
                                            allowDeleteFirstRowAfterSave={Boolean(true)}
                                            printPackQtyValue={printPackQty}
                                            onSaveSuccess={async (currentValues, productIndex, totalSummary, isDeleteFirstRowOfSavedItems) => {

                                                setOpenItemV1Dialog({ ...openItemV1Dialog, status: false, data: {} })

                                                // setFieldValue(
                                                //     `products.${productIndex}.total`,
                                                //     {
                                                //         ...initialProductValues.total,
                                                //         cbm: totalSummary?.cbm,
                                                //         weight: totalSummary?.weight,
                                                //         value: totalSummary?.value
                                                //     }
                                                // )
                                                // setFieldValue(`products.${productIndex}.items`, currentValues?.items)

                                                await onSubmitCreateItems({ productId: id, items: currentValues?.items })

                                                if (isDeleteFirstRowOfSavedItems === true) {
                                                    // console.log('need to delete first row', dataItems)

                                                    let firstItemId = dataItems.length > 0 ? dataItems[0]?.id : ""

                                                    if (!firstItemId) {
                                                        promptMessage(false, `${t("failedToDeleteTheFirstRowOfSavedItems")}`)
                                                    }

                                                    await handleBulkItemsDelete({ itemIds: [firstItemId] })

                                                }
                                            }}
                                        />

                                    </Box>
                                )
                            }
                        }}
                    />
            }

            {/* <CommonDialog
                open={openDialog?.status}
                // open={openDialog?.status ? openDialog?.status : openItemV1Dialog?.status}
                handleOnExit={(event, reason) => {

                    if (reason === `backdropClick`) {
                        return false
                    }

                    setOpenDialog({ ...openDialog, status: false, data: {} })
                    // setOpenItemV1Dialog({ ...openItemV1Dialog, status: false, data: {} })

                    return true
                    // closeCustomDrawer()
                    // setRefreshDataGrid(val => val + 1)

                }}
                handleOnSelect={(value) => {
                    setSelectedOption(value)
                }}
                tableVersionTypes={tableVersionTypes}
                selectedOption={selectedOption}
                // t={t}
                configs={{
                    data: openDialog?.data,
                    dialogProps: {
                        maxWidth: 'xl',
                    },
                    RenderDialogTitle: ({ data }) => {

                        // console.log('data', data);

                        return (
                            <Typography
                                sx={{
                                    fontWeight: '800'
                                }}
                            >
                                {`${openDialog?.title}`}
                            </Typography>
                        )
                    },
                    RenderDialogContent: ({ data }) => {
                        return (
                            <Box sx={{ p: 2, }}>
                                {
                                    // Number(authDataUserId) === 38 ?
                                    (selectedOption === tableVersionTypes.tableGridV2.id) ?
                                        (
                                            <AddProductItemsV2
                                                // documentId={data?.id}
                                                productId={id}
                                                productIndex={openDialog?.productIndex}
                                                courierTrackingNo={openDialog?.courierTrackingNo}
                                                currentData={openDialog?.data}
                                                allowDeleteFirstRowAfterSave={Boolean(true)}
                                                onSaveSuccess={async (currentValues, productIndex, totalSummary, isDeleteFirstRowOfSavedItems) => {

                                                    setOpenDialog({ ...openDialog, status: false, data: {} })

                                                    // console.log('currentValues', currentValues, totalSummary)

                                                    // setFieldValue(
                                                    //     `products.${productIndex}.total`,
                                                    //     {
                                                    //         ...initialProductValues.total,
                                                    //         cbm: totalSummary?.cbm,
                                                    //         weight: totalSummary?.weight,
                                                    //         value: totalSummary?.value
                                                    //     }
                                                    // )
                                                    // setFieldValue(`products.${productIndex}.items`, currentValues?.items)

                                                    await onSubmitCreateItems({ productId: id, items: currentValues?.items })

                                                    if (isDeleteFirstRowOfSavedItems === true) {
                                                        // console.log('need to delete first row', dataItems)

                                                        let firstItemId = dataItems.length > 0 ? dataItems[0]?.id : ""

                                                        if (!firstItemId) {
                                                            promptMessage(false, `${t("failedToDeleteTheFirstRowOfSavedItems")}`)
                                                        }

                                                        await handleBulkItemsDelete({ itemIds: [firstItemId] })

                                                    }

                                                }}
                                            />
                                        )
                                        :
                                        (
                                            <AddProductItems
                                                // documentId={data?.id}
                                                productId={id}
                                                productIndex={openDialog?.productIndex}
                                                courierTrackingNo={openDialog?.courierTrackingNo}
                                                currentData={openDialog?.data}
                                                onSaveSuccess={async (currentValues, productIndex, totalSummary) => {

                                                    setOpenDialog({ ...openDialog, status: false, data: {} })

                                                    // console.log('currentValues', currentValues, totalSummary)

                                                    // setFieldValue(
                                                    //     `products.${productIndex}.total`,
                                                    //     {
                                                    //         ...initialProductValues.total,
                                                    //         cbm: totalSummary?.cbm,
                                                    //         weight: totalSummary?.weight,
                                                    //         value: totalSummary?.value
                                                    //     }
                                                    // )
                                                    // setFieldValue(`products.${productIndex}.items`, currentValues?.items)

                                                    await onSubmitCreateItems({ productId: id, items: currentValues?.items })

                                                }}
                                            />
                                        )
                                }
                            </Box>
                        )
                    }
                }}
            /> */}

            <RenderFabs
                productId={id}
                editableData={editableData}
                selectedIds={selectedIds}
                handleAddProductItem={handleAddProductItem}
                handleAddProductItemV1={handleAddProductItemV1}
                handleDeleteBulkItems={handleDeleteBulkItems}
                handleUpdateBulkItems={handleUpdateBulkItems}
                t={t}
            // selectedFabGridTable={selectedFabGridTable}
            // tableVersionTypes={tableVersionTypes}
            />


            {/* {JSON.stringify(editableData.pendingUpdate)} */}


        </Box>
    )
}